import axios from "axios";
import store from "../../store/index";

function firstDefined() {
  for (var i = 0; i < arguments.length; i++) {
    var val = arguments[i];
    if (val !== undefined && val !== null) {
      return val;
    }
  }
  return undefined;
}

const emptyForm = () => ({
  moduleId: '',
  resourceCode: '',
  resourceName: '',
  resourceType: '',
  routePath: '',
  permissionKey: '',
  displayOrder: 0,
  isActive: true,
  isMenuVisible: true,
  isPermissionControlled: false,
  parentResourceId: ''
});

const emptyErrors = () => ({
  moduleId: '',
  resourceCode: '',
  resourceName: '',
  displayOrder: ''
});

export default {
  name: 'ModuleModal',

  props: {
    parentOptions: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      baseUrl: process.env.VUE_APP_Service_URL,
      idToken: store.getters.getIdToken,
      isShowModuleModal: false,
      isEditMode: false,
      isSubmitting: false,
      editingRecordId: '',
      formData: emptyForm(),
      errors: emptyErrors()
    };
  },

  methods: {
    openModuleModal(module,parentNode) {
      this.resetForm();

      if (module) {
        this.isEditMode = true;
        this.editingRecordId = firstDefined(module.id, '');
        this.formData = {
          moduleId: firstDefined(module.moduleId, ''),
          resourceCode: firstDefined(module.resourceCode, module.resourcecode, ''),
          resourceName: firstDefined(module.resourceName,module.resourcename,''),
          resourceType: firstDefined(module.resourceType, ''),
          routePath: firstDefined(module.routePath, ''),
          permissionKey: firstDefined(module.permissionKey, ''),
          displayOrder: firstDefined(module.displayOrder, 0),
          isActive: firstDefined(module.active, module.isActive, true),
          isMenuVisible: firstDefined(module.isMenuVisible, true),
          isPermissionControlled: firstDefined(module.isPermissionControlled, false),
          parentResourceId: firstDefined(module.parentResourceId, '')
        };
      } else {
        this.isEditMode = false;
         if (parentNode) {
          // Pre-select parent + auto-fetch its Module ID
          this.formData.parentResourceId = parentNode.id;
          this.formData.moduleId = parentNode.moduleId;
        }

       
      }
          this.isShowModuleModal = true;
    },

    closeModuleModal() {
      this.isShowModuleModal = false;
      this.resetForm();
    },

    resetForm() {
      this.formData = emptyForm();
      this.editingRecordId = '';
      this.errors = emptyErrors();
    },
    validateField(fieldName) {
      const field = this.formData[fieldName];

      switch (fieldName) {
        case 'moduleId':
          if (!field || String(field).trim().length === 0) {
            this.errors.moduleId = 'Module ID is required';
          } else {
            this.errors.moduleId = '';
          }
          break;
        case 'resourceCode':
          if (!field || String(field).trim().length === 0) {
            this.errors.resourceCode = 'Resource code is required';
          } else {
            this.errors.resourceCode = '';
          }
          break;
        case 'resourceName':
          if (!field || String(field).trim().length === 0) {
            this.errors.resourceName = 'Resource name is required';
          } else {
            this.errors.resourceName = '';
          }
          break;
        case 'displayOrder':
          if (field !== null && field !== '' && isNaN(field)) {
            this.errors.displayOrder = 'Display order must be a number';
          } else {
            this.errors.displayOrder = '';
          }
          break;
      }
    },

    validateForm() {
      let isValid = true;

      ['moduleId', 'resourceCode', 'resourceName', 'displayOrder'].forEach(field => {
        this.validateField(field);
        if (this.errors[field]) {
          isValid = false;
        }
      });

      return isValid;
    },

    buildPayload() {
      const payload = { ...this.formData };
      if (this.isEditMode && this.editingRecordId) {
        payload.id = this.editingRecordId;
      }

      return payload;
    },

    async handleSubmit() {
      if (!this.validateForm()) {
        return;
      }

      this.isSubmitting = true;
      const payload = this.buildPayload();
      console.log('AppResource payload:', JSON.stringify(payload, null, 2));

      try {
        const response = this.isEditMode
          ? await axios.put(
              `${this.baseUrl}/admin/appresource/update?id=${encodeURIComponent(this.editingRecordId)}`,
              payload,
              {
                headers: {
                  'Content-Type': 'application/json',
                  'Authorization': `Bearer ${this.idToken}`
                }
              }
            )
          : await axios.post(
              `${this.baseUrl}/admin/appresource/create`,
              payload,
              {
                headers: {
                  'Content-Type': 'application/json',
                  'Authorization': `Bearer ${this.idToken}`
                }
              }
            );

        this.$emit(this.isEditMode ? 'appresource-updated' : 'appresource-created', response.data);
        alert(this.isEditMode ? 'AppResource updated successfully' : 'Appesource created successfully');
        this.closeModuleModal();
      } catch (error) {
        const responseData = error.response && error.response.data;
        const message = (responseData && responseData.message) || error.message || 'Failed to save resource';
        alert(`Error: ${message}`);
        console.error('Error saving module:', error);
        console.error('Full error response:', responseData);
      } finally {
        this.isSubmitting = false;
      }
    }
  }
};